export const sendGaEvent = (action, label) => window.ga('send', 'event', 'Configurator', action, label);
